/**
 * scrollRefToTop — reset a React Native scrollable to its top.
 *
 * Handles both ScrollView (`scrollTo`) and FlatList / SectionList /
 * VirtualizedList (`scrollToOffset`) refs. Used by useScrollResetOnFocus to
 * put a screen back at the top when it regains focus: native-stack keeps
 * screens mounted on web, so an inner ScrollView's position otherwise persists
 * across navigations and the screen reopens half-scrolled.
 *
 * No-op when the ref is empty or exposes neither method, so callers don't have
 * to guard. Kept DOM/RN-free so the dispatch logic is unit-testable.
 */
export interface ScrollableRef {
  current?: {
    scrollTo?: (opts: { x?: number; y?: number; animated?: boolean }) => void;
    scrollToOffset?: (opts: { offset: number; animated?: boolean }) => void;
  } | null;
}

export function scrollRefToTop(ref: ScrollableRef | null | undefined): void {
  const node = ref?.current;
  if (!node) return;
  if (typeof node.scrollTo === 'function') {
    node.scrollTo({ y: 0, animated: false });
  } else if (typeof node.scrollToOffset === 'function') {
    node.scrollToOffset({ offset: 0, animated: false });
  }
}
